<div class="p-20">
  <div class="" fxLayout="column" fxLayoutAlign="space-between start" style="width:100%">
    <mat-card class="example-card mat-elevation-z4 mb-20"style="width:100%">
      <div class="" fxLayout="row" fxLayoutAlign="space-between start">
        <h2 style="color:{{OverallStatus_color}};font-weight: 900;font-size: 30px;" *ngIf="OverallStatus==0">{{'AUDITORIA.TEX_AUDI_NOT_AUTORI' | translate}}</h2>
        <h2 style="color:{{OverallStatus_color}}:font-weight: 900;font-size: 30px;" *ngIf="OverallStatus==1"> {{'AUDITORIA.TEX_AUDI_YE_AUTORI' | translate}}</h2>
        <button mat-raised-button color="primary" (click)="auditoriaManual()">
          {{'ACCIONES.LISTA.auditMan' | translate}}
          <mat-icon>assignment_turned_in</mat-icon>
        </button>

      </div>
      <mat-card-content>
        <div  fxLayout="row" fxLayoutAlign="space-between center" >
          <div class=""  fxLayout="column" fxLayoutAlign="space-between stretch"  fxFlex="30">
            <h3>{{'AUDITORIA.TITL_AUDI_DEV_TR' | translate}}</h3>
            <canvas baseChart
            [data]="doughnutChartDataTiempoRespuesta"
            [labels]="doughnutChartLabelsTiempoRespuesta"
            [chartType]="doughnutChartType"
            [colors]="donutColorsTiempoRespuesta"
            [plugins]="doughnutChartPluginsTiempoRespuesta"
            [options]="doughnutChartOptionsTiempoRespuesta"
            >
          </canvas>
        </div>
        <div class=""  fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="30">
          <h3>{{'AUDITORIA.TITL_AUDI_DEV_PC' | translate}}</h3>
          <canvas baseChart
          [data]="doughnutChartDataPreguntaControl"
          [labels]="doughnutChartLabelsPreguntaControl"
          [chartType]="doughnutChartType"
          [colors]="donutColorsPreguntaControl"
          [plugins]="doughnutChartPluginsPreguntaControl"
          [options]="doughnutChartOptionsPreguntaControl"
          >
        </canvas>
      </div>
      <div class=""  fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="30">
        <h3>{{'AUDITORIA.TITL_AUDI_DEV_PA' | translate}}</h3>
        <canvas baseChart
        [data]="doughnutChartDataPreguntaAleatoria"
        [labels]="doughnutChartLabelsPreguntaAleatoria"
        [chartType]="doughnutChartType"
        [colors]="donutColorsPreguntaAleatoria"
        [plugins]="doughnutChartPluginsPreguntaAleatoria"
        [options]="doughnutChartOptionsPreguntaAleatoria"
        >
      </canvas>
    </div>
  </div>
</mat-card-content>
    </mat-card>
    <button mat-raised-button color="primary" (click)="exportTable();" *ngIf="mostrarTabla" >{{'CONSULTARENCUESTA.BOTON_DESCARGA_EXCEL' | translate }}</button>
<table  mat-table [dataSource]="tablaAuditoriaAutomatizada" class="mat-elevation-z8" style="width:100%"  *ngIf="mostrarTabla">

  <!--- Note that these columns can be defined in any order.
    The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="HierarchicalPath">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > HierarchicalPath</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.HierarchicalPath' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element"> {{element.HierarchicalPath}} </td>
    </ng-container>
    <ng-container matColumnDef="RespondentCount">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > RespondentCount</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.RespondentCount' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let i = index;">
        {{element.RespondentCount}}
      </td>
    </ng-container>
    <!-- Name Column -->
    <ng-container matColumnDef="Time_DeviationCount">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > Time_DeviationCount</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.Time_DeviationCount' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let a = index;">
        {{element.Time_DeviationCount}}
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="Time_DeviationPercentage">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > Time_DeviationPercentage</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.Time_DeviationPercentage' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let e = index;">
        {{element.Time_DeviationPercentage}}
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="ControlStatement_DeviationCount">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > ControlStatement_DeviationCount</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.ControlStatement_DeviationCount' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let u = index;">
        {{element.ControlStatement_DeviationCount}}
      </td>
    </ng-container>
    <ng-container matColumnDef="ControlStatement_DeviationPercentage">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > ControlStatement_DeviationPercentage</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.ControlStatement_DeviationPercentage' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let u = index;">
        {{element.ControlStatement_DeviationPercentage}}
      </td>
    </ng-container>

    <ng-container matColumnDef="RandomStatement_DeviationPercentage">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > RandomStatement_DeviationPercentage</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.RandomStatement_DeviationPercentage' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let o = index;">
        {{element.RandomStatement_DeviationPercentage}}
      </td>
    </ng-container>

    <ng-container matColumnDef="RandomStatement_DeviationCount">
      <!-- <th mat-header-cell *matHeaderCellDef  class="lftBrd" > RandomStatement_DeviationCount</th> -->
      <th mat-header-cell *matHeaderCellDef  class="lftBrd" > {{'AUDITORIA.COLUMNAS.RandomStatement_DeviationCount' | translate}}</th>
      <td mat-cell class="lftBrd" *matCellDef="let element;let u = index;">
        {{element.RandomStatement_DeviationCount}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator *ngIf="mostrarTabla" class="tamaño" style-paginator  showFirstLastButtons [showTotalPages]="20" [pageSizeOptions]="[20, 50, 100, 500]" [length]="tablaAuditoriaAutomatizada.data.length"></mat-paginator>

  </div>
</div>
